

const questionnaireRoutes = [
  {
    path: '/questionnaire',
    component: () => import('@/components/layout/kokwatch/KokwatchLayout.vue'),
    children: [
      {
        path: 'envheavymetal/survey/:refId?',
        name: 'envHeavyMetalSurvey',
        props: true,
        component: () => import('@/views/questionnaire/envHeavyMetal/EnvHeavyMetalSurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'envheavymetal/list',
        name: 'envHeavyMetalList',
        props: true,
        component: () => import('@/views/questionnaire/envHeavyMetal/EnvHeavyMetalList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'envheavymetal/map',
        name: 'envHeavyMetalMap',
        props: true,
        component: () => import('@/views/questionnaire/envHeavyMetal/EnvHeavyMetalMap.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
    ]
  }
];

export default questionnaireRoutes;
